import { render, staticRenderFns } from "./JobCategory.vue?vue&type=template&id=2c8d3d51&scoped=true&"
import script from "../../../services/applicant/home/job-category.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/home/job-category.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_category.css?vue&type=style&index=0&id=2c8d3d51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d3d51",
  null
  
)

export default component.exports